/* tslint:disable */
/* eslint-disable */
/**
 * AgentAssistService
 * Agent Assist API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AnalyticsAggrQuestionsScore
 */
export interface AnalyticsAggrQuestionsScore {
    /**
     * 
     * @type {string}
     * @memberof AnalyticsAggrQuestionsScore
     */
    contactImportId: string;
    /**
     * 
     * @type {string}
     * @memberof AnalyticsAggrQuestionsScore
     */
    promptGroupName: string;
    /**
     * 
     * @type {string}
     * @memberof AnalyticsAggrQuestionsScore
     */
    questionKey: string;
    /**
     * 
     * @type {string}
     * @memberof AnalyticsAggrQuestionsScore
     */
    questionId: string;
    /**
     * 
     * @type {boolean}
     * @memberof AnalyticsAggrQuestionsScore
     */
    isParent: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AnalyticsAggrQuestionsScore
     */
    isChild: boolean;
    /**
     * 
     * @type {string}
     * @memberof AnalyticsAggrQuestionsScore
     */
    scorePercentage: string;
}


/**
 * Check if a given object implements the AnalyticsAggrQuestionsScore interface.
 */
export function instanceOfAnalyticsAggrQuestionsScore(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "contactImportId" in value;
    isInstance = isInstance && "promptGroupName" in value;
    isInstance = isInstance && "questionKey" in value;
    isInstance = isInstance && "questionId" in value;
    isInstance = isInstance && "isParent" in value;
    isInstance = isInstance && "isChild" in value;
    isInstance = isInstance && "scorePercentage" in value;

    return isInstance;
}

export function AnalyticsAggrQuestionsScoreFromJSON(json: any): AnalyticsAggrQuestionsScore {
    return AnalyticsAggrQuestionsScoreFromJSONTyped(json, false);
}

export function AnalyticsAggrQuestionsScoreFromJSONTyped(json: any, ignoreDiscriminator: boolean): AnalyticsAggrQuestionsScore {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'contactImportId': json['contactImportId'],
        'promptGroupName': json['promptGroupName'],
        'questionKey': json['questionKey'],
        'questionId': json['questionId'],
        'isParent': json['isParent'],
        'isChild': json['isChild'],
        'scorePercentage': json['scorePercentage'],
    };
}

export function AnalyticsAggrQuestionsScoreToJSON(value?: AnalyticsAggrQuestionsScore | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'contactImportId': value.contactImportId,
        'promptGroupName': value.promptGroupName,
        'questionKey': value.questionKey,
        'questionId': value.questionId,
        'isParent': value.isParent,
        'isChild': value.isChild,
        'scorePercentage': value.scorePercentage,
    };
}

